<template>
  <div class="stock-money">
    <!-- tab -->
    <ContentHeader :stock-nav="true" :show-back="false" />

    <div class="content-container">
      <!-- 查询条件 -->
      <div class="query-panel">
        <div class="btn-line btn-line-right">
          <el-button
            class="btn-orange-plain"
            size="small"
            @click="dialogMoneyInfoVisible = true"
            >查看配额信息</el-button
          >
          <el-button
            class="btn-orange-plain"
            size="small"
            @click="searchStockCart"
            >查看金额配额购物车</el-button
          >
          <el-button
            class="btn-orange-plain"
            size="small"
            @click="goToMoneyOrder"
            >查看金额配额订单</el-button
          >
        </div>
        <el-form
          :model="queryParam"
          label-position="right"
          label-width="100px"
          size="small"
          class="query-form"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="商品名称">
                <el-input
                  v-model="queryParam.itemName"
                  placeholder="请输入商品名称"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="商品编码">
                <el-input
                  v-model="queryParam.itemCode"
                  placeholder="请输入商品编码"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="配额名称">
                <el-input
                  v-model="queryParam.quotaName"
                  placeholder="请输入配额名称"
                  class="panel-input"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="所在仓库">
                <el-select
                  v-model="queryParam.warehouseId"
                  placeholder="请选择所在仓库"
                  clearable
                >
                  <el-option
                    v-for="option in warehouseList"
                    :key="option.key"
                    :label="option.warehouseName"
                    :value="option.warehouseId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="btn-line">
          <el-button class="btn-blue-plain" @click="searchQuery" size="small"
            >查询</el-button
          >
          <el-button class="btn-grey-plain" @click="resetQuery" size="small"
            >重置</el-button
          >
        </div>
      </div>

      <!-- 数据显示 -->
      <div class="table-show" :loading="loading">
        <el-table :data="stockItemList" class="while-data-table">
          <el-table-column label="图片">
            <template slot-scope="scope">
              <div class="item-image" @click="handleViewPic(scope.row)">
                <img :src="getImageUrl(scope.row)" />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="itemName" label="商品名称"></el-table-column>
          <el-table-column prop="itemCode" label="商品编码"></el-table-column>
          <el-table-column prop="quotaName" label="所属配额"></el-table-column>
          <el-table-column label="单价">
            <template slot-scope="scope">
              <span>￥{{ scope.row.itemPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="warehouseName"
            label="所在仓库"
          ></el-table-column>
          <el-table-column
            prop="availableAmount"
            label="可用库存"
          ></el-table-column>
          <el-table-column prop="orgCode" label="区域编码"></el-table-column>
          <el-table-column prop="buTypeName" label="品牌部门"></el-table-column>
          <el-table-column
            clign="center"
            label="操作"
            width="150"
            class-name="small-padding"
          >
            <template slot-scope="scope">
              <div style="line-height: 35px;">
                <i
                  class="iconfont iconzu19 cursor"
                  v-if="
                    scope.row.availableAmount > 0 &&
                      scope.row.availableQuota > scope.row.itemPrice
                  "
                  @click="handleAddCart(scope.row)"
                  title="加入购物车"
                />
                <i
                  class="el-icon-shopping-bag-1 cursor"
                  v-if="
                    scope.row.availableAmount > 0 &&
                      scope.row.availableQuota > scope.row.itemPrice
                  "
                  @click="handleOrderNow(scope.row)"
                  title="立即下单"
                ></i>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <el-row class="while-data-table-footer">
          <el-col>
            <el-pagination
              background
              :current-page="queryParam.page"
              :page-size="queryParam.pageSize"
              :total="total"
              layout="total, prev, pager, next"
              @current-change="handleCurrentChange"
            />
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 配额信息弹框 -->
    <el-dialog
      title="配额信息"
      :visible.sync="dialogMoneyInfoVisible"
      width="70%"
    >
      <el-table
        size="mini"
        :data="quotaList"
        :loading="loading"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column
          label="配额名称"
          prop="quotaName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="总配额"
          prop="totalQuota"
          align="center"
        ></el-table-column>
        <el-table-column
          label="已用配额"
          prop="usedQuota"
          align="center"
        ></el-table-column>
        <el-table-column
          label="可用配额"
          prop="availableQuota"
          align="center"
        ></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button
          class="btn-red-plain"
          size="small"
          @click="dialogMoneyInfoVisible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import { commonUtils } from '@/utils/common'
export default {
  name: 'stock-money',
  components: {
    ContentHeader
  },
  data () {
    return {
      loading: false,
      dialogMoneyInfoVisible: false,
      queryParam: {
        page: 1,
        pageSize: 10,
        itemName: '',
        itemCode: '',
        warehouseId: '',
        quotaName: ''
      },
      stockItemList: [],
      warehouseList: [],
      quotaList: [],
      total: 0
    }
  },
  activated () {
    this.getQuota()
    this.getStockItemList()
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.getWarehouseList()
      this.getQuota()
      this.getStockItemList()
    },
    // 获取配额信息
    getQuota () {
      this.loading = true
      this.$store
        .dispatch('getAmountQuota')
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.quotaList = res.data.resultData.clientQuotaDetailList
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 获取商品列表
    getStockItemList () {
      this.loading = true
      this.$store
        .dispatch('getAmountItemList', this.queryParam)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.stockItemList = res.data.resultData.stockAmountItemList
            this.total = res.data.resultData.pageInfo.totalCounts
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 查看金额配额订单
    goToMoneyOrder () {
      this.$router.push({
        path: '/stock/stock-money-order'
      })
    },
    // 查看购物车
    searchStockCart () {
      this.$router.push({
        path: '/stock/cart',
        query: { moduleTypeName: 'money' }
      })
    },
    // 加入购物车
    handleAddCart (scope) {
      let params = {
        itemId: scope.itemId,
        moduleType: '04',
        itemQuantity: 1,
        warehouseId: scope.warehouseId,
        orgCode: scope.orgCode,
        buType: scope.buType,
        quotaId: scope.quotaId
      }
      this.loading = true
      this.$store
        .dispatch('addStockCart', params)
        .then(res => {
          this.loading = false
          if (res.data.resultCode === '0') {
            this.$message.success('商品加入购物车成功')
          }
        })
        .catch(() => {
          this.loading = false
          this.$message.error('商品加入购物车失败')
        })
    },

    // 立即发货
    handleOrderNow (scope) {
      this.$confirm('是否确认单个商品立即下单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$router.push({
            path: '/stock/fill-order',
            query: { type: 'money', linkId: scope.linkId }
          })
        })
        .catch(() => {})
    },
    // 查询
    searchQuery () {
      this.queryParam.page = 1
      this.getStockItemList()
    },
    // 重置
    resetQuery () {
      this.queryParam = this.$options.data().queryParam
      this.getStockItemList()
    },
    // 获取仓库列表
    getWarehouseList () {
      this.$store.dispatch('getWarehouseListAll').then(response => {
        this.warehouseList = response.data.resultData.warehouseList
      })
    },
    handleViewPic (item) {
      window.open(this.getImageUrl(item))
    },
    getImageUrl (item) {
      let imageUri = ''
      if (item.itemImageUriList && item.itemImageUriList.length > 0) {
        imageUri = item.itemImageUriList[0]
      }
      return commonUtils.getImageUrl(imageUri)
    },
    // 翻页
    handleCurrentChange (val) {
      this.queryParam.page = val
      this.getStockItemList()
    }
  }
}
</script>

<style lang="scss" scoped>
.no-quota-data {
  text-align: center;
  margin: 10px 0 15px;
  color: #888;
}
.btn-line {
  padding-top: 0;
}
.btn-line-right {
  text-align: right;
  margin-bottom: 10px;
}
.iconzu19,
.el-icon-shopping-bag-1 {
  font-size: 22px;
  color: $base-plain;
  margin-left: 20px;
}
.item-image {
  width: 70px;
  height: 70px;
  margin: 0 auto;
  border: 1px solid $base-grey;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  img {
    max-width: 95%;
    max-height: 95%;
    border: none;
    cursor: pointer;
  }
}
</style>
